module.exports = __webpack_public_path__ + "img/behind.a27acc65.svg";